module.exports = __webpack_public_path__ + "img/logo-plx.a4e39296.png";